import { ZODIAC_SIGNS } from "../../Data";
import {
  INPUT_LABEL_1,
  INPUT_LABEL_10,
  INPUT_LABEL_2,
  INPUT_LABEL_3,
  INPUT_LABEL_4,
  INPUT_LABEL_5,
  INPUT_LABEL_6,
  INPUT_LABEL_7,
  INPUT_LABEL_8,
  INPUT_LABEL_9,
} from "../../helpers/constants";

export const formFields = [
  {
    id: 1,
    label: INPUT_LABEL_1,
    name: "name",
    required: true,
  },
  {
    id: 2,
    label: INPUT_LABEL_2,
    name: "DOB",
    required: true,
    type: "date",
  },
  {
    id: 3,
    label: INPUT_LABEL_3,
    name: "time_of_birth",
    required: true,
    type: "time",
  },
  {
    id: 4,
    label: INPUT_LABEL_4,
    name: "place_of_birth",
    required: true,
  },
];

export const formFields2 = [
  {
    id: 1,
    label: INPUT_LABEL_1,
    name: "name",
    required: true,
  },
  {
    id: 2,
    label: INPUT_LABEL_2,
    name: "DOB",
    required: true,
    type: "date",
  },
  {
    id: 3,
    label: INPUT_LABEL_3,
    name: "time_of_birth",
    required: true,
    type: "time",
  },
  {
    id: 6,
    label: INPUT_LABEL_5,
    name: "gender",
    required: true,
    type: "radio",
    options: [
      { name: "Male", value: "Male" },
      { name: "Female", value: "Female" },
    ],
  },
  {
    id: 7,
    label: INPUT_LABEL_4,
    name: "place_of_birth",
    required: true,
  },
];

export const formFieldsNumerology = [
  ...formFields2,
  {
    id: 7,
    label: INPUT_LABEL_8,
    name: "varshaphal_year",
    required: true,
    type: "number",
  },
];

export const formFieldsSign = [
  {
    id: 1,
    label: INPUT_LABEL_9,
    name: "zodiac",
    required: true,
    type: "radio",
    options: ZODIAC_SIGNS?.map((item) => ({
      ...item,
      value: item?.name,
    })),
  },
];

export const formFieldCity = [
  {
    id: 1,
    label: INPUT_LABEL_10,
    name: "city",
    required: true,
  },
];

export const formFieldDate = [formFields2[0], formFields2[1], formFields2[3]];
